import { useScreenClass } from 'react-grid-system';
import styled from 'styled-components';
import FlexBox, { FlexGrow } from './FlexBox';
import { ClickableIcon } from './Icon';
import Modal from './Modal';
import { StyledText, TextSize, TextStatus } from './Text';

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 20px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const Label = styled.h5`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
type SkillDetailModalProps = {
  isOpen?: boolean;
  data: any;
  setOpen: (x: boolean) => void;
};
const SkillDetailModal = ({
  isOpen,
  setOpen,
  data,
}: SkillDetailModalProps): JSX.Element => {
  const screenClass = useScreenClass();

  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: {
            zIndex: '999958',
          },
          content: {
            maxWidth: '413px',
            padding: '0 24px',
            color: 'black',
            background: '#FFFFFF',
            border: '1px solid #E7EBEE',
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.07)',
            borderRadius: '8px',
          },
        }}>
        <CustomFlex>
          <FlexGrow>
            <Header>{data.skill.title}</Header>
          </FlexGrow>
          <ClickableIcon
            size={3.125}
            fixedWidth={false}
            color='black'
            name="close"
            onClick={() => setOpen(false)}
          />
        </CustomFlex>
        <CustomFlex
          style={{
            borderBottom: 'none',
            alignItems: 'flex-start',
            overflowY: 'scroll',
          }}>
          <FlexGrow>
            <CustomFlexPlain>
              <CustomGrowPlain>
                <Label>Title</Label>
              </CustomGrowPlain>
              <FlexGrow>
                <StyledText style={{ color: '#505050' }}>
                  {data.skill.title}
                </StyledText>
              </FlexGrow>
            </CustomFlexPlain>
            <CustomFlexPlain>
              <CustomGrowPlain>
                <Label>Skill Code</Label>
              </CustomGrowPlain>
              <FlexGrow>
                <StyledText style={{ color: '#505050', paddingRight: '5px' }}>
                  {data.skill.skill_code}
                </StyledText>
              </FlexGrow>
            </CustomFlexPlain>
            <CustomFlexPlain>
              <CustomGrowPlain>
                <Label>Assessment</Label>
              </CustomGrowPlain>
              <FlexGrow>
                <StyledText style={{ color: '#505050' }}>
                  {data?.assessment?.title}
                </StyledText>
              </FlexGrow>
            </CustomFlexPlain>
            <CustomFlexPlain>
              <CustomGrowPlain>
                <Label>Description:</Label>
              </CustomGrowPlain>
              <FlexGrow>
                <StyledText
                  textSize={TextSize.sidebar}
                  status={TextStatus.muted}>
                  {data.assessment.description}
                </StyledText>
              </FlexGrow>
            </CustomFlexPlain>
          </FlexGrow>
        </CustomFlex>
      </Modal>
    </>
  );
};

export default SkillDetailModal;
